var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/badge.tsx";
import "core-js/modules/es.array.includes.js";
import classNames from 'clsx';
import React from 'react';

/** Badge to display on a user's profile. */
const Badge = _ref => {
  let {
    title,
    slug
  } = _ref;
  const fallback = !['patron', 'admin', 'moderator', 'opaque', 'badge:donor'].includes(slug); // Don't render the expert badge

  if (slug === 'badge:expert') {
    return null;
  }

  return /*#__PURE__*/React.createElement("span", {
    "data-testid": "badge",
    className: classNames('inline-flex items-center px-2 py-0.5 rounded text-xs font-medium', {
      'bg-fuchsia-700 text-white': slug === 'patron',
      'bg-emerald-800 text-white': slug === 'badge:donor',
      'bg-black text-white': slug === 'admin',
      'bg-cyan-600 text-white': slug === 'moderator',
      'bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-gray-100': fallback,
      'bg-white bg-opacity-75 text-gray-900': slug === 'opaque'
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 5
    }
  }, title);
};

export default Badge;